<template>
  <div class="ShareHeader">
    <span>点击右上角</span>
    <img class="m-l-10 m-r-20 rightTopImage" src="@/view/card/assets/right-top.png" />
    <span>分享给律所成员</span>
    <img class="shareImage" src="@/view/card/assets/share.png" />
    <img class="rightTopArrowImage" src="@/view/card/assets/right-top-arrow.png" />
  </div>
</template>

<script>

export default {
  setup() {
    return {}
  },
}
</script>

<style lang="scss">
.ShareHeader {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 40px;
  width: 100%;
  height: 160px;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.3);
  border-radius: 0px 0px 20px 20px;
  font-size: 28px;
  color: #999;
  .rightTopImage {
    width: 64;
    height: 40px;
  }
  .shareImage {
    width: 88px;
    height: 88px;
  }
  .rightTopArrowImage {
    width: 154px;
    height: 100px;
    position: absolute;
    top: 0;
    right: 28px;
  }
}
</style>